import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="224813" id="hero" className="bg-background text-foreground relative flex min-h-[85vh] items-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_outdoor_living_luxury.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-black/40" />

      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
      backgroundSize: "3rem 3rem"
    }} />

      {}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="font-default text-white text-5xl font-bold tracking-tight sm:text-6xl lg:text-7xl">
            Ready to Scale Your Business?
          </h1>
          
          <p className="font-default mt-6 text-xl leading-8 text-white/90 sm:text-2xl">
            Join the ClifRock installer network and transform your construction 
            business with our high-speed panel masonry system. Build faster, 
            reduce labor, and deliver premium outdoor living.
          </p>
          
          <div className="mt-10 flex items-center gap-x-6">
            <Link to="/ApplyNowPage">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-6 text-lg shadow-lg transition-transform hover:scale-105">
                Become a ClifRock Installer
                <ArrowRight className="ml-2 size-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}